import { render, staticRenderFns } from "./StudipTreeList.vue?vue&type=template&id=decb8b30&scoped=true&"
import script from "./StudipTreeList.vue?vue&type=script&lang=js&"
export * from "./StudipTreeList.vue?vue&type=script&lang=js&"
import style0 from "./StudipTreeList.vue?vue&type=style&index=0&id=decb8b30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decb8b30",
  null
  
)

export default component.exports